// import Service from "../../../service/api"

const LanguageModule = {
    namespaced: true,
    state: {
        language: "EN",
        sidebar: false,
    },
    mutations: {
        setLanguage(state, res) {
            state.language = res
        },
        setDefaultLanguage(state) {
            state.language = "EN"
        },
        setChangingSidebar(state, input) {
            state.sidebar = input;
            localStorage.setItem("sidebar", input);
        }
    },
    actions: {
        commitLanguage({ commit }, val) {
            commit('setLanguage', val.toUpperCase());
        },
    },
    getters: {
        getLanguage(state) {
            return state.language
        },
        getChangingSidebarStatus(state) {
            return state.sidebar
        }
    }
}

export default LanguageModule;